import * as m from "@paraglide/messages"
import { PlaydataButtonLink, PlaydataFigure, PlaydataSection } from "@playdata/PlaydataPrimitives"
import type { SupportedLocale } from "@site-types/content"
import { createFileRoute } from "@tanstack/react-router"
import { playdataRouteHead } from "@utils/playdata-route-head"

export const Route = createFileRoute("/$locale/playdata/streamer-report")({
  head: ({ params }) => {
    const locale = params.locale as SupportedLocale
    return playdataRouteHead({
      description: m.playdata_streamerReport_meta_description({}, { locale }),
      locale,
      path: "/playdata/streamer-report",
      title: m.playdata_streamerReport_meta_title({}, { locale }),
    })
  },
  component: RouteComponent,
})

function RouteComponent() {
  const { locale: raw } = Route.useParams()
  const locale = raw as SupportedLocale

  return (
    <>
      <PlaydataSection className="py-[2.4rem]">
        <h1 className="text-center text-[2.2rem] md:text-[2.4rem]">
          <strong>{m.playdata_streamerReport_heading({}, { locale })}</strong>
        </h1>
      </PlaydataSection>

      <PlaydataSection tone="light">
        <div className="grid items-center gap-[4rem] md:grid-cols-2">
          <PlaydataFigure
            alt=""
            height={485}
            src="/images/playdata/streamer-tool.png"
            width={650}
          />
          <div className="flex flex-col items-start gap-[2rem]">
            <h2 className="text-[2.2rem] leading-[1.4] md:text-[2.6rem]">
              <strong>{m.playdata_streamerReport_discover_heading({}, { locale })}</strong>
            </h2>
            <p className="text-[1.5rem] leading-[1.7]">
              {m.playdata_streamerReport_discover_body({}, { locale })}
            </p>
            <PlaydataButtonLink
              className="self-stretch"
              params={{ locale }}
              to="/$locale/contact"
            >
              {m.playdata_common_contactCta({}, { locale })}
            </PlaydataButtonLink>
          </div>
        </div>
      </PlaydataSection>

      <PlaydataSection>
        <div className="flex flex-col items-center gap-[2rem] text-center">
          <h2 className="text-[2.4rem] md:text-[2.8rem]">
            {m.playdata_streamerReport_games_heading({}, { locale })}
          </h2>
          <p className="max-w-[60ch] text-[1.5rem] leading-[1.7]">
            {m.playdata_streamerReport_games_body({}, { locale })}
          </p>
          <PlaydataFigure
            alt=""
            className="mt-[1.6rem] max-w-[900px]"
            height={1445}
            src="/images/playdata/streamer-insights.png"
            width={1500}
          />
          <PlaydataButtonLink
            className="mt-[1.6rem]"
            params={{ locale }}
            to="/$locale/contact"
          >
            {m.playdata_common_contactCta({}, { locale })}
          </PlaydataButtonLink>
        </div>
      </PlaydataSection>
    </>
  )
}
